import React, {FC} from 'react'
import {useEffectOnce} from 'react-use'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import './style/index.less'
import {Icon} from "@/components";
import log from "@/utils/log";

interface ActivitedTypes {
 showActive?: boolean
  onChangeShowActive?: (bool:boolean) => void
  getActive?: () => void
}

type ActivitedProps = StylesType & ActivitedTypes

const Activited: FC<ActivitedProps> = props => {
  const {prefixCls = 'gc_activated_', showActive=false, onChangeShowActive, getActive} = props
  const active = () => {
    log({eventId: 'E2400', pageId: 'P24', ext: ''})
    getActive && getActive()
  }
  const close =() => {
    log({eventId: 'E2404', pageId: 'P24', ext: ''})
    onChangeShowActive && onChangeShowActive(false)
  }
  useEffectOnce(() => {
    log({eventId: 'E2403', pageId: 'P24', ext: ''})
  })
  return (
    <>
      {showActive?<div className={classnames(prefixCls)}>
        <div className={classnames(prefixCls+'body')}>
          <div className={classnames(prefixCls + 'title')}>恭喜您，<br/>
            获得免费体验资格
          </div>
          <div className={classnames(prefixCls + 'content')}>请点击下面按钮，立即获得体验设备</div>
          <div className={classnames(prefixCls + 'getActive')} onClick={() => active()}>立即领取</div>
          <div className={classnames(prefixCls+'close')} onClick={() => close()}>
            <Icon type='iconxinjianicon' className={classnames(prefixCls+'icon')}/>
          </div>
        </div>
      </div>:null}
    </>
  )
}

export default Activited
